import CrudManager from "@/components/admin/CrudManager";

const ICONS = ["Car", "Plane", "PlaneTakeoff", "Navigation", "ArrowRight", "Repeat", "Train", "Briefcase", "Camera", "Clock", "Map", "Truck", "Bus", "Landmark", "MapPin"];

export default function ServicesAdmin() {
  return (
    <CrudManager
      title="Services" subtitle="Manage taxi services." testid="admin-services"
      endpoint={{ public: "/services", admin: "/admin/services" }} queryKey="services"
      columns={[
        { key: "title", label: "Title" },
        { key: "slug", label: "Slug" },
        { key: "short", label: "Description" },
      ]}
      fields={[
        { key: "title", label: "Service Title" },
        { key: "icon", label: "Icon", type: "select", options: ICONS },
        { key: "short", label: "Short Description", type: "textarea", rows: 2 },
        { key: "description", label: "Full Description", type: "textarea", rows: 4 },
        { key: "order", label: "Sort Order", type: "number" },
      ]}
    />
  );
}
